<!-- NEW REPLY INPUT BOX -->
<ng-container *ngIf="!reply">
    <app-comment-input
        label="Your comment"
        placeholder="Your comment"
        [(value)]="newReply"
        [contentLength]="contentLength"
        actionButtonLabel="Post comment"
        (action)="createReply()"
        (cancel)="toggleReplyInputBox(); cancelReplyCreation()"
        [disabledAction]="!newReply.trim()"
    ></app-comment-input>
</ng-container>
<!-- / NEW REPLY INPUT BOX -->

<!-- COMMENT REPLY -->
<ng-container *ngIf="reply">
    <div class="comment-container">
        <ng-container *ngIf="!editMode && !confirmedDelete">
            <div class="comment-user-heading">
                <sync-list [isSelectable]="false" [ListItems]="[{
                    isInteractive: false,
                    primaryText: reply.author_name | b64,
                    secondaryText: reply.updated_at | relativeTime,
                    leadAdornmentConfig: {
                        enabled: true,
                        type: 'avatar',
                        size: 'large',
                        avatarConfig: {
                            type: 'avatar',
                            url: authorAvatar,
                            initials: reply.author_name | b64,
                            size: 40,
                            randomColor: true
                        }
                    },
                    trail1AdornmentConfig: {
                        enabled: user?.id === reply.author_id && tempSession === reply.temp_session,
                        type: 'iconButton',
                        size: 'large',
                        onClick: editReply,
                        iconButtonConfig : {
                            iconName: 'edit',
                            size: 'large',
                            tooltipText: 'Edit'
                        }
                    },
                    trail2AdornmentConfig: {
                        enabled: (user?.id === ownerId || 
                        
                        
                        (user && user.exists && user?.id === reply.author_id)),
                        type: 'iconButton',
                        size: 'large',
                        onClick: toggleConfirm,
                        iconButtonConfig : {
                            iconName: 'delete',
                            size: 'large',
                            tooltipText: 'Delete'
                        }
                    }
                }]"></sync-list>
            </div>
            <div class="comment-text body-2">
                {{reply.content}}
            </div>
        </ng-container>
        <app-comment-input
            *ngIf="editMode"
            label="Your comment"
            placeholder="Your comment"
            [(value)]="replyEdition"
            [contentLength]="contentLength"
            actionButtonLabel="Save changes"
            (action)="updateReply()"
            (cancel)="cancelEditMode()"
            [disabledAction]="!replyEdition.trim()"
        ></app-comment-input>
        <div class="confirm-delete" *ngIf="confirmedDelete">
            <div class="subtitle-2">Are you sure you want to delete this comment?</div>
            <div class="body-2">{{reply.content}}</div>
            <div class="comment-form-buttons">
                <sync-button class="cancel-comment-button"
                    type="flat"
                    label="Cancel"
                    [onClick]="cancelConfirm">
                </sync-button>
                <sync-button class="post-comment-button"
                    color="critical"
                    type="filled"
                    [onClick]="deleteReply"
                    label="Delete comment">
                </sync-button>
            </div>
        </div>
    </div>
</ng-container>
<!-- / COMMENT REPLY -->

